import React from "react";
import "./Page.css";
import useStore from "../store.js";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";

import Button from "../components/Button/Button.js";
import { useParams } from "react-router-dom";
import { useNavigateWithVars } from "../hooks/useNavigateWithVars";

const Page = (props) => {
  const getLocalized = useStore((state) => state.getLocalized);
  const game = useStore((state) => state.game);
  const gameState = useStore((state) => state.gameState);
  const currentHint = useStore((state) => state.currentHint);
  //const revealNextHint = useStore((state) => state.revealNextHint);
  // const character = useStore((state) => state.character);
  const navigateTo = useNavigateWithVars();
  // const hint = useStore((state) => state.hint);

  if (!game) return null;

  return (
    <div
      className={`Page${props.className ? " " + props.className : ""} Hints`}
    >
      <h2>{getLocalized("texts", "HeadlineAufgedeckteHinweise")}</h2>

      {currentHint > -1 &&
        getLocalized("game", "Hints").map((hint, index) => {
          if (index > currentHint) return null;
          return (
            <Button
              key={index}
              onClick={() => {
                navigateTo(`/hint/${index + 1}`);
              }}
            >
              <strong>{`${getLocalized("texts", "Hinweis")} ${
                index + 1
              }`}</strong>
            </Button>
          );
        })}
      {currentHint === -1 && <p>{getLocalized("texts", "KeineHinweise")}</p>}
    </div>
  );
};

export default Page;
